export default {
  'common.save': '保存',
  'common.cancel': 'キャンセル',
  'common.delete': '削除',
  'common.edit': '編集',
  'common.confirm': '確認',
  'common.close': '閉じる',
  'common.search': '検索',
  'common.loading': '読み込み中...',
  'common.processing': '処理中...',
  'common.submit': '送信',
  'common.back': '戻る',
  'common.next': '次へ',
  'common.previous': '前へ',
  'common.upload': 'アップロード',
  'common.download': 'ダウンロード',
  'common.downloadAll': 'すべてダウンロード',
  'common.refresh': '更新',
  'common.retry': '再試行',
  'common.copy': 'コピー',
  'common.copied': 'コピーしました',
  'common.selectAll': 'すべて選択',
  'common.clear': 'クリア',
  'common.clearAll': 'すべてクリア',
  'common.apply': '適用',
  'common.reset': 'リセット',
  'common.filter': 'フィルター',
  'common.sort': '並べ替え',
  'common.export': 'エクスポート',
  'common.import': 'インポート',
  'common.preview': 'プレビュー',
  'common.view': '表示',
  'common.add': '追加',
  'common.remove': '削除',
  'common.rename': '名前を変更',
  'common.share': '共有',
  'common.settings': '設定',
  'common.logout': 'ログアウト',
  'common.profile': 'プロフィール',
  'common.yes': 'はい',
  'common.no': 'いいえ',
  'common.ok': 'OK',
  'common.areYouSure': 'よろしいですか？',
  'common.actionCannotBeUndone': 'この操作は元に戻せません。',
  'common.noData': 'データがありません',
  'common.noResultsFound': '結果が見つかりません',
  'common.somethingWentWrong': '問題が発生しました',
  'common.pleaseTryAgain': 'もう一度お試しください',
  'common.success': '成功',
  'common.error': 'エラー',
  'common.warning': '警告',
  'common.info': '情報',
  'common.optional': '任意',
  'common.required': '必須',
  'common.name': '名前',
  'common.title': 'タイトル',
  'common.description': '説明',
  'common.status': 'ステータス',
  'common.actions': '操作',
  'common.date': '日付',
  'common.time': '時刻',
  'common.createdAt': '作成日時',
  'common.updatedAt': '更新日時',
  'common.type': '種類',
  'common.size': 'サイズ',
  'common.file': 'ファイル',
  'common.folder': 'フォルダ',
  'common.files': 'ファイル',
  'common.folders': 'フォルダ',
  'common.all': 'すべて',
  'common.none': 'なし',
  'common.send': '送信',
  'common.sending': '送信中...',
  'common.new': '新規',
  'common.create': '作成',
  'common.duplicate': '複製',
  'common.move': '移動',
  'common.moveTo': '移動先',
  'common.selectFile': 'ファイルを選択',
  'common.chooseFile': 'ファイルを選択',
  'common.dragDropFilesHere': 'ここにファイルをドラッグ＆ドロップ',
  'common.or': 'または',
  'common.browse': '参照',
  'common.continue': '続行',
  'common.skip': 'スキップ',
  'common.done': '完了',
  'common.finish': '終了',
  'common.start': '開始',
  'common.stop': '停止',
  'common.pause': '一時停止',
  'common.resume': '再開',
  'common.enabled': '有効',
  'common.disabled': '無効',
  'common.active': '有効',
  'common.inactive': '無効',
  'common.draft': '下書き',
  'common.published': '公開済み',
  'common.archive': 'アーカイブ',
  'common.unarchive': 'アーカイブを解除',
  'common.favourite': 'お気に入り',
  'common.favourites': 'お気に入り',
  'common.pin': 'ピン留め',
  'common.unpin': 'ピン留めを解除',
  'common.expand': '展開',
  'common.collapse': '折りたたむ',
  'common.showMore': 'さらに表示',
  'common.showLess': '表示を減らす',
  'common.language': '言語',
  'common.darkMode': 'ダークモード',
  'common.lightMode': 'ライトモード',
  'common.help': 'ヘルプ',
  'common.feedback': 'フィードバック',
  'common.notifications': '通知',
  'common.rows': '行',
  'common.column': '列',
  'common.total': '合計',
  'common.page': 'ページ',
  'common.of': '/',
  'common.notes': 'メモ',
};
